import { connect } from "react-redux";
import InvoiceLob from "./invoiceLobList";
import { bindActionCreators } from "redux";
import { getTaxInvoiceLob,bulkAssigneTaxInvoices } from "services/redux/sales/businessListing/action";
import {getReportee, search, newAssignee} from "../../../services/redux/BulkAssignment/action";
import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  postSalesList: state.approvedSalesListReducer.postSalesList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
  reportee: state.bulkAssignmentReducer.reportee,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      fetchZones,
      getTaxInvoiceLob,
      newAssignee,
      getReportee,
      bulkAssigneTaxInvoices,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceLob);
